import { render, staticRenderFns } from "./Subnavbar-inventario.vue?vue&type=template&id=2b12ece0&scoped=true"
import script from "./Subnavbar-inventario.vue?vue&type=script&lang=js"
export * from "./Subnavbar-inventario.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-inventario.vue?vue&type=style&index=0&id=2b12ece0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12ece0",
  null
  
)

export default component.exports